import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from '../../../../../../UI/AsideModal/Form/FormLabel'
import SelectCustom from '../../../../Select/SelectCustom'

const TagManagement = () => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  const handleSelectChange = (selectedOptions) => {
    const selectedValues = Array.isArray(selectedOptions)
      ? selectedOptions.map((option) => option.value)
      : selectedOptions
        ? [selectedOptions.value]
        : []

    changeValues(selectedValues, 'tags')
  }

  return (
    <FormField>
      <FormLabel isRequired>Добавить тег</FormLabel>
      <SelectCustom
        placeholder={'Выберите тег'}
        valueID={modalValue.tags || []}
        onChange={handleSelectChange}
        apiLinkCRM={'integration/tags'}
        error={check('tags')}
        isMulti
      />
    </FormField>
  )
}

export default TagManagement
